import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, SECTION_STYLE_FIELDS } from './_fields'

/** Newsletter band in the theme's grape; the form shows only with an external form URL. */
export const schema: ComponentSchema = {
  type: 'cta',
  label: 'Newsletter',
  description: 'A grape band with a title and text beside an email form.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Newsletter band' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Join our parents’ club' },
    { key: 'subtitle', label: 'Text', type: 'string', default: 'New toys, offers and gift ideas by age, once a month.' },
    { key: 'placeholder', label: 'Email placeholder', type: 'string', default: 'Email address' },
    { key: 'buttonText', label: 'Button text', type: 'string', default: 'Subscribe' },
    { key: 'formAction', label: 'Form URL', type: 'string', help: 'An external newsletter form; without it the band shows no form.' },
    ...SECTION_STYLE_FIELDS,
  ],
}
